import { useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Sidebar } from './Sidebar'
import { Header } from './Header'

// Route -> catalog key under `pageTitles`; routes without one fall back to the app name.
const pageTitleKeys: Record<string, string> = {
  '/dashboard': 'dashboard',
  '/packages': 'packages',
  '/users': 'users',
  '/businesses': 'businesses',
  '/features': 'features',
  '/analytics': 'analytics',
  '/documents': 'documents',
  '/help': 'help',
}

export function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const location = useLocation()
  const { t } = useTranslation()

  const baseRoute = '/' + location.pathname.split('/')[1]
  const titleKey = pageTitleKeys[baseRoute]
  const title = titleKey ? t(`pageTitles.${titleKey}`) : t('app.name')

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header onMenuClick={() => setSidebarOpen(true)} title={title} />
        <main className="flex-1 overflow-y-auto p-4 sm:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
